export type EventLevel = "destroy" | "hit" | "gain" | "info";

const EVENT_LIFETIME_MS = 5_000;
const MAX_VISIBLE = 8;

interface Entry {
  el: HTMLElement;
  expires: number;
}

/** One shared prune timer, scheduled to next expiry. */
export class EventLog {
  private root: HTMLDivElement;
  private entries: Entry[] = [];
  private timer: number | null = null;

  constructor(parent: HTMLElement = document.body) {
    this.root = document.createElement("div");
    this.root.id = "eventlog";
    parent.appendChild(this.root);
  }

  push(message: string, level: EventLevel = "info"): void {
    const el = document.createElement("div");
    el.className = `event event-${level}`;
    el.textContent = message;
    this.root.prepend(el);
    this.entries.unshift({ el, expires: performance.now() + EVENT_LIFETIME_MS });

    while (this.entries.length > MAX_VISIBLE) {
      const dropped = this.entries.pop();
      dropped?.el.remove();
    }
    this.schedulePrune();
  }

  private schedulePrune(): void {
    if (this.timer !== null || this.entries.length === 0) return;
    const next = this.entries[this.entries.length - 1].expires - performance.now();
    this.timer = window.setTimeout(() => {
      this.timer = null;
      const now = performance.now();
      while (this.entries.length > 0
          && this.entries[this.entries.length - 1].expires <= now) {
        const e = this.entries.pop();
        e?.el.remove();
      }
      this.schedulePrune();
    }, Math.max(16, next));
  }
}
